import { useState, useMemo } from "react";
import { Button, Checkbox } from "..";
import "./AuthForm.scss";
import { CaptchaWidget } from "../CaptchaWidget/CaptchaWidget";
import {
  POSTAL_CODE_PATTERN,
  POSTAL_CODE_TITLE,
  STREET_PATTERN,
  STREET_TITLE,
} from "../../features/address";
import { PHONE_PATTERN, PHONE_TITLE } from "../../features/phone";
import {
  PASSWORD_MIN_LENGTH,
  PASSWORD_MIN_LENGTH_MESSAGE,
} from "../../features/password";

function RegisterForm({
  onSwitchToLogin,
  onSubmit,
  errorMessage,
  registrationinng,
  setRegistrationing,
  setCaptchaToken,
  ref
}) {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    street: "",
    postalCode: "",
    city: "",
    password: "",
    confirmPassword: "",
    agree: false,
  });

  const updateField = (key) => (e) => {
    const val = e?.target ? e.target.value : e;
    setForm((prev) => ({ ...prev, [key]: val }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setRegistrationing(true);
    onSubmit?.(form);
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <div className="auth-form__grid">
        <div className="auth-form__field">
          <label className="auth-form__label" htmlFor="reg-firstname">
            Meno
          </label>
          <input
            id="reg-firstname"
            type="text"
            className="auth-form__input"
            placeholder="Ján"
            required
            value={form.firstName}
            onChange={updateField("firstName")}
            autoComplete="given-name"
          />
        </div>
        <div className="auth-form__field">
          <label className="auth-form__label" htmlFor="reg-lastname">
            Priezvisko
          </label>
          <input
            id="reg-lastname"
            type="text"
            className="auth-form__input"
            placeholder="Novák"
            required
            value={form.lastName}
            onChange={updateField("lastName")}
            autoComplete="family-name"
          />
        </div>
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="reg-email">
          Email
        </label>
        <input
          id="reg-email"
          name="email"
          type="email"
          className="auth-form__input"
          placeholder="vas@email.com"
          value={form.email}
          required
          onChange={updateField("email")}
          autoComplete="username"
        />
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="reg-phone">
          Telefónne číslo
        </label>
        <input
          id="reg-phone"
          type="tel"
          className="auth-form__input"
          placeholder="0905 123 456"
          maxLength={20}
          pattern={PHONE_PATTERN}
          title={PHONE_TITLE}
          required
          value={form.phone}
          onChange={updateField("phone")}
          autoComplete="tel"
        />
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="reg-street">
          Ulica a číslo domu
        </label>
        <input
          id="reg-street"
          type="text"
          className="auth-form__input"
          placeholder="Hlavná 12"
          maxLength={255}
          pattern={STREET_PATTERN}
          title={STREET_TITLE}
          required
          value={form.street}
          onChange={updateField("street")}
          autoComplete="street-address"
        />
      </div>

      <div className="auth-form__grid">
        <div className="auth-form__field">
          <label className="auth-form__label" htmlFor="reg-postal-code">
            PSČ
          </label>
          <input
            id="reg-postal-code"
            type="text"
            inputMode="numeric"
            className="auth-form__input"
            placeholder="831 06"
            maxLength={6}
            pattern={POSTAL_CODE_PATTERN}
            title={POSTAL_CODE_TITLE}
            required
            value={form.postalCode}
            onChange={updateField("postalCode")}
            autoComplete="postal-code"
          />
        </div>
        <div className="auth-form__field">
          <label className="auth-form__label" htmlFor="reg-city">
            Mesto
          </label>
          <input
            id="reg-city"
            type="text"
            className="auth-form__input"
            placeholder="Bratislava"
            maxLength={100}
            required
            value={form.city}
            onChange={updateField("city")}
            autoComplete="address-level2"
          />
        </div>
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="reg-password">
          Heslo
        </label>
        <input
          id="reg-password"
          name="new-password"
          type="password"
          className="auth-form__input"
          placeholder={`Minimálne ${PASSWORD_MIN_LENGTH} znakov`}
          minLength={PASSWORD_MIN_LENGTH}
          title={PASSWORD_MIN_LENGTH_MESSAGE}
          value={form.password}
          required
          onChange={updateField("password")}
          autoComplete="new-password"
        />
      </div>

      <div className="auth-form__field">
        <label className="auth-form__label" htmlFor="reg-confirm">
          Potvrdenie hesla
        </label>
        <input
          id="reg-confirm"
          name="confirm-password"
          type="password"
          className="auth-form__input"
          placeholder="Zopakujte heslo"
          value={form.confirmPassword}
          required
          onChange={updateField("confirmPassword")}
          autoComplete="new-password"
        />
      </div>

      <Checkbox
        label="Súhlasím s obchodnými podmienkami a spracovaním osobných údajov"
        checked={form.agree}
        onChange={(val) => setForm((prev) => ({ ...prev, agree: val }))}
      />
      <CaptchaWidget ref={ref} onVerify={(token) => setCaptchaToken(token)} />
      {errorMessage && <p className="auth-form__error">{errorMessage}</p>}

      <div className="auth-form__submit">
        <Button
          variant="primary"
          type="submit"
          style={{ width: "100%" }}
          disabled={registrationinng}
        >
          {registrationinng ? "Registrujem..." : "Vytvoriť účet"}
        </Button>
      </div>

      {onSwitchToLogin && (
        <p className="auth-form__switch">
          Už máte účet?{" "}
          <button
            type="button"
            className="auth-form__link"
            onClick={onSwitchToLogin}
          >
            Prihláste sa
          </button>
        </p>
      )}
    </form>
  );
}

export default RegisterForm;
